import { call, put, takeEvery } from 'redux-saga/effects';
import {
  GET_EXPENSE_CATEGORY,
  ADD_NEW_EXPENSE_CATEGORY,
  UPDATE_EXPENSE_CATEGORY,
  GET_EXPENSE_LIST,
  ADD_NEW_EXPENSE,
  UPDATE_EXPENSE,
} from './actionTypes';
import {
  getExpenseCategorySuccess,
  getExpenseCategoryFail,
  addExpenseCategorySuccess,
  addExpenseCategoryFail,
  updateExpenseCategorySuccess,
  updateExpenseCategoryFail,
  getExpenseListSuccess,
  getExpenseListFail,
  addExpenseSuccess,
  addExpenseFail,
  updateExpenseSuccess,
  updateExpenseFail,
} from './actions';

import { addNewExpenseCategory,
  updateExpenseCategory,
  getExpenseCategories,
  addNewExpense,
  updateExpense,
  getExpenses,
  getExpenseList,
  deleteExpenseCategory,
  deleteExpense,
} from '../../helpers/fakebackend_helper';


// Worker Saga: Fetch expense categories
function* fetchExpenseCategory() {
  try {
    const data = yield call(fetchExpenseCategories); // Replace with your API call
    yield put(getExpenseCategorySuccess(data));
  } catch (error) {
    yield put(getExpenseCategoryFail(error.message));
  }
}

// Worker Saga: Add new expense category
function* createExpenseCategory(action) {
  try {
    const transformedPayload = {
      "name": action.payload.name,
      "split_by_percentage": true,
      "split1_user": action.payload.user1,
      "split2_user": action.payload.user2,
      "split1_percentage": action.payload.split1,
      "split2_percentage": action.payload.split2
    };
    console.log('transformedPayload', transformedPayload);
    
    const data = yield call(addNewExpenseCategory, transformedPayload); 
    yield put(addExpenseCategorySuccess(data));
  } catch (error) {
    yield put(addExpenseCategoryFail(error.message));
  }
}

// Worker Saga: Update expense category
function* modifyExpenseCategory(action) {
  try {
    const data = yield call(updateExpenseCategory, action.payload); // Replace with your API call
    yield put(updateExpenseCategorySuccess(data));
  } catch (error) {
    yield put(updateExpenseCategoryFail(error.message));
  }
}

// Worker Saga: Fetch expense list
function* fetchExpenseList() {
  try {
    const data = yield call(fetchExpenseList); // Replace with your API call
    yield put(getExpenseListSuccess(data));
  } catch (error) {
    yield put(getExpenseListFail(error.message));
  }
}

// Worker Saga: Add new expense
function* createExpense(action) {
  try {
    const data = yield call(addExpense, action.payload); // Replace with your API call
    yield put(addExpenseSuccess(data));
  } catch (error) {
    yield put(addExpenseFail(error.message));
  }
}

// Worker Saga: Update expense
function* modifyExpense(action) {
  try {
    const data = yield call(updateExpense, action.payload); // Replace with your API call
    yield put(updateExpenseSuccess(data));
  } catch (error) {
    yield put(updateExpenseFail(error.message));
  }
}

// Watcher Saga: Watch for actions
export default function* expenseSaga() {
  yield takeEvery(GET_EXPENSE_CATEGORY, fetchExpenseCategory);
  yield takeEvery(ADD_NEW_EXPENSE_CATEGORY, createExpenseCategory);
  yield takeEvery(UPDATE_EXPENSE_CATEGORY, modifyExpenseCategory);
  yield takeEvery(GET_EXPENSE_LIST, fetchExpenseList);
  yield takeEvery(ADD_NEW_EXPENSE, createExpense);
  yield takeEvery(UPDATE_EXPENSE, modifyExpense);
}